import store from "../store";
import defaultRoutes from "../router/defaultRoutes";

export default {
  setCurrentPath(to) {
    let menuList = store.state.permission.routes;
    let getCurrentRoutes = (data) => {
      let resArr = [];
      for (const page of data) {
        if (
          page.name == this.getRouteWhiteList(to.name) ||
          (to.meta && to.meta.parentName && page.name === to.meta.parentName)
        ) {
          resArr.push(page);
          return resArr;
        }
        if (page.children) {
          let res = getCurrentRoutes(page.children);
          if (res.length) {
            resArr.push(page);
            resArr = [...resArr, ...res];
            return resArr;
          }
        }
      }
      return resArr;
    };
    // 处理一级菜单重复问题
    let res = this.unique(getCurrentRoutes(menuList), "path");

    if (res.length) {
      store.commit("common/SET_CURRENT_PATH", [...res]);
    }
    // 新增菜单返回
    if (res.length) {
      let len = res.length;
      const openedA = [res[0].path];
      const openedB = [res[0].path, res[res.length - 1].path];
      const openeds = len > 1 ? openedB : openedA;
      store.commit("common/SETUP_OPENEDS", openeds);
    }
  },

  // 设置默认选中菜单
  // setMenuActive() {
  //   if (store.state.routers.length && !store.state.openeds.length) {
  //     let menu = store.state.routers[0];
  //     if (menu.children.length) {
  //       store.state.openeds = [
  //         menu.id.toString(),
  //         menu.children[0].id.toString(),
  //       ];
  //       store.commit("common/SET_CURRENT_PATH", [menu, menu.children[0]]);
  //     } else {
  //       store.state.openeds = [menu.id.toString()];
  //       store.commit("common/SET_CURRENT_PATH", [menu]);
  //     }
  //   }
  // },

  // 设置历史路由
  setHistoryRoutes(path) {
    let routers = store.state.permission.routes.filter((item) => {
      return !item.hidden;
    });
    let historyRoutes = JSON.parse(
      JSON.stringify(store.state.common.historyRouter)
    );
    for (let i = 0; i < routers.length; i++) {
      const route = routers[i];
      if (route.path === path) {
        //如果有relatedPermission则不存入historyRoutes
        if (!route.meta || !route.meta.relatedPermission) {
          console.log("route", route);
          historyRoutes.push(route);
        }
      } else {
        const childRoute =
          route.children &&
          route.children.find((child) => {
            return child.path === path;
          });
        if (childRoute) {
          //如果有relatedPermission则不存入historyRoutes
          if (!childRoute.meta || !childRoute.meta.relatedPermission) {
            console.log("route", childRoute);
            historyRoutes.push(childRoute);
          }
        }
      }
    }
    historyRoutes = this.unique(historyRoutes, "path");
    store.commit("common/SET_HISTORY_ROUTER", historyRoutes);
  },

  // 获取三级菜单白名单
  getRouteWhiteList(name) {
    let obj = defaultRoutes[0].children.find((child) => {
      return name == child.name;
    });
    if (obj) {
      return obj.meta.parentName;
    }
    return name;
  },

  // 数组去重
  unique(array, key) {
    let obj = {};
    let uniqueArr = array.reduce((cur, next) => {
      obj[next[key]] ? "" : (obj[next[key]] = true && cur.push(next));
      return cur;
    }, []);
    return uniqueArr;
  },

  // 校验当前路由是否有权限
  checkRoute(from, to) {
    const name = to.meta.parentName || to.name;
    let menuList = store.state.permission.routes;
    menuList = menuList.filter((item) => {
      return !item.hidden;
    });
    let isTrue = false;
    for (let i = 0; i < menuList.length; i++) {
      const children = menuList[i].children;
      for (let j = 0; j < children.length; j++) {
        const route = children[j];
        if (route.name === name) {
          isTrue = true;
          break;
        }
      }
    }
    const filterRouteWhiteList = ["/user/editPassword"];
    if (from.path === "/" || filterRouteWhiteList.includes(to.path)) {
      return true;
    }
    return isTrue;
  },
};
